import { initTranslatedItems } from '../utils/translationProcessor';
import { LOOKUP_PAGE_TITLE } from '../constants';

export const ADULT_MINOR_HEADER = 'Are you caring for a child or an adult?';

export const CHILD_TEXT = 'Child';
export const ADULT_TEXT = 'Adult';

export const CONTINUE_BUTTON_TEXT = 'Continue';
export const CANCEL_LINK_TEXT = 'Cancel';

// Translation configuration for adult-minor page
export const ADULT_MINOR_TRANSLATION_CONFIG = [
  { key: 'ADULT_MINOR_HEADER', value: ADULT_MINOR_HEADER, message: ADULT_MINOR_HEADER },
  { key: 'CHILD_TEXT', value: CHILD_TEXT, message: CHILD_TEXT },
  { key: 'ADULT_TEXT', value: ADULT_TEXT, message: ADULT_TEXT },
  { key: 'CONTINUE_BUTTON_TEXT', value: CONTINUE_BUTTON_TEXT, message: CONTINUE_BUTTON_TEXT },
  { key: 'CANCEL_LINK_TEXT', value: CANCEL_LINK_TEXT, message: CANCEL_LINK_TEXT },
  { key: 'LOOKUP_PAGE_TITLE', value: LOOKUP_PAGE_TITLE, message: LOOKUP_PAGE_TITLE }
];

// Helper function to process translated items
export const processAdultMinorTranslations = (translatedItems: any) => {
  translatedItems = initTranslatedItems(translatedItems);

  const {
    [ADULT_MINOR_HEADER]: ADULT_MINOR_HEADER_TRANSLATED = ADULT_MINOR_HEADER,
    [CHILD_TEXT]: CHILD_TEXT_TRANSLATED = CHILD_TEXT,
    [ADULT_TEXT]: ADULT_TEXT_TRANSLATED = ADULT_TEXT,
    [CONTINUE_BUTTON_TEXT]: CONTINUE_BUTTON_TEXT_TRANSLATED = CONTINUE_BUTTON_TEXT,
    [CANCEL_LINK_TEXT]: CANCEL_LINK_TEXT_TRANSLATED = CANCEL_LINK_TEXT,
    [LOOKUP_PAGE_TITLE]: LOOKUP_PAGE_TITLE_TRANSLATED = LOOKUP_PAGE_TITLE
  } = translatedItems;

  return {
    ADULT_MINOR_HEADER: ADULT_MINOR_HEADER_TRANSLATED,
    CHILD_TEXT: CHILD_TEXT_TRANSLATED,
    ADULT_TEXT: ADULT_TEXT_TRANSLATED,
    CONTINUE_BUTTON_TEXT: CONTINUE_BUTTON_TEXT_TRANSLATED,
    CANCEL_LINK_TEXT: CANCEL_LINK_TEXT_TRANSLATED,
    LOOKUP_PAGE_TITLE: LOOKUP_PAGE_TITLE_TRANSLATED
  };
};
